(function() {
  "use strict";

  angular.module("sempraWebapp").component("karcherAlarms", {
    templateUrl: "app/alarms/karcherAlarmsComponent/karcherAlarms.html",
    controller: karcherAlarmsController,
    bindings: {},
    controllerAs: "vm"
  });

  function karcherAlarmsController(
    deviceActions,
    messagesStore,
    karcherActiveAlarmsService,
    messageActions
  ) {
    var vm = this;

    deviceActions.getAllDevices().then(function(devicesData) {
      var karcherDevices = devicesData.filter(function(device) {
        return device.deviceType === "KARCHER";
      });

      if (messagesStore.getKarcherMessages()) {
        vm.karcherAlarmList = karcherActiveAlarmsService.mapFacilityNameToActiveAlarmList(
          karcherDevices,
          messagesStore.getKarcherMessages()
        );
      } else {
        messageActions.getKarcherAlarms().then(function(data) {
          vm.karcherAlarmList = karcherActiveAlarmsService.mapFacilityNameToActiveAlarmList(
            karcherDevices,
            data
          );
        });
      }
    });
  }
})();
